module.exports = __webpack_public_path__ + "img/9788998614140.fd73f196.jpg";